import { Dispatch, makeActionCreator } from "../../store/types";
import { Color } from "../../models";

export const SET_COLORS = "color/SET_COLORS";
export const SET_CHOSEN_COLOR = "color/SET_CHOSEN_COLOR";
export const SET_COLORS_LOADING = "color/SET_COLORS_LOADING";
export const TOGGLE_CHECKBOX = "color/TOGGLE_CUSTOM_COLOR_CHECKBOX";
export const RESET = "color/RESET";

const setColors = makeActionCreator<Color[]>(SET_COLORS as typeof SET_COLORS);
const setColorsLoading = makeActionCreator<
  boolean
>(SET_COLORS_LOADING as typeof SET_COLORS_LOADING);
export const setChosenColor = makeActionCreator<
  Color | undefined
>(SET_CHOSEN_COLOR as typeof SET_CHOSEN_COLOR);
export const toggleCheckbox = makeActionCreator(
  TOGGLE_CHECKBOX as typeof TOGGLE_CHECKBOX,
);
export const reset = makeActionCreator(RESET as typeof RESET);

export const fetchColors = () => async (dispatch: Dispatch, _, http) => {
  dispatch(setColorsLoading(true));

  try {
    const { data = [] }: any = await http.get("data/color_palettes", {
      params: {
        limit: 100,
        sort: "position asc",
      },
    });
    dispatch(setColors(data));
  } catch (error) {
    throw error;
  } finally {
    dispatch(setColorsLoading(false));
  }
};



// WEBPACK FOOTER //
// ./src/routes/WizardColorChoice/actions.ts